import { Copyable } from '@components'

import { Flex, Spacing, Text } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

import { Contact } from '@features/contacts/types/contact'

interface ClientInformationOptionalFieldsProps {
  contact: Contact
}

export const ClientInformationOptionalFields = ({ contact }: ClientInformationOptionalFieldsProps) => {
  const { t } = useTranslation()

  return (
    <Flex flexDirection="column" alignItems="flex-start" gap={Spacing.S12}>
      {contact.vatNo && (
        <>
          <Text weight="bold">{t('contact.detail.tax_id')}</Text>
          <Copyable valueToCopy={contact.vatNo}>{contact.vatNo}</Copyable>
        </>
      )}

      {contact.ean && (
        <>
          <Text weight="bold">{t('contact.detail.ean')}</Text>
          <Copyable valueToCopy={contact.ean}>{contact.ean}</Copyable>
        </>
      )}

      {contact.paymentTermsDays != null && (
        <>
          <Text weight="bold">{t('contact.detail.payment_terms')}</Text>
          <Text>{t('contact.detail.payment_terms_days', { days: contact.paymentTermsDays })}</Text>
        </>
      )}

      {contact.currencyId && (
        <>
          <Text weight="bold">{t('contact.detail.currency')}</Text>
          <Text>{contact.currencyId}</Text>
        </>
      )}

      {contact.invoicingLanguage && (
        <>
          <Text weight="bold">{t('contact.detail.invoicing_language')}</Text>
          <Text>{t(`contact.detail.invoicing_language.${contact.invoicingLanguage}`)}</Text>
        </>
      )}
    </Flex>
  )
}
